import React, { Component } from 'react'
import { Button, Icon } from '@driftt/tide-core-legacy'
import { HELP_CENTER_HELPDOC_URL } from 'constants/HelpDocConstants'
import styles from './style.styl'


const DRIFT_HELP_LINK = '/help'


class DriftHelp extends Component {

  render() {
    const { isConnected } = this.props

    return (
      <div>
        <div className="drift-help-description">
          <p>Drift Help integrates seamlessly with Driftbot.</p>
        </div>
        <div className="drift-help-connected-status">
          { isConnected && (
            <div className="drift-help-connected">
              <Icon width={20} name="check-circle"/>
              <p>Connected</p>
            </div>
          )}
        </div>
        <div className="help-center-buttons">
          <Button type="secondary" selected href={DRIFT_HELP_LINK}>
            Setup Drift Help
          </Button>
        </div>        
      </div>    
    )
  }
}

export default (DriftHelp)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/DriftHelp.js